import "./components/accordion.js";
import "./remove-cycle-links.js";
import "./tracking.js";
import "./form-loading-state.js";
import "./hubspot-identify.js";


// (function ($) {
//   /* Contact Forms 7 - validations phone
//  --------------------------------------------- */
//   $(document).on("change keyup input click", "input[type='tel']", function () {
//     if (this.value.match(/[^\d\s\+\-\(\)]/g)) {
//       this.value = this.value.replace(/[^\d\s\+\-\(\)]/g, "");
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const burgerMenu = document.querySelector(".burger-menu");
//   const burgerButton = document.querySelector(".header__burger");
//   const closeButton = document.querySelector(".close-button");

//   if (burgerButton) {
//     burgerButton.addEventListener("click", function () {
//       burgerMenu.classList.toggle("open");
//       document.body.classList.toggle("menu-open");
//     });
//   }

//   if (closeButton) {
//     closeButton.addEventListener("click", function () {
//       burgerMenu.classList.remove("open");
//       document.body.classList.remove("menu-open");
//     });
//   }


// });


$("img:not([title])").each(function () {
  if ($(this).attr("alt") !== "") $(this).attr("title", $(this).attr("alt"));
});

$("img:not([alt])").each(function () {
  if ($(this).attr("title") !== "") $(this).attr("alt", $(this).attr("title"));
});

// $(document).ready(function () {
//   $("select").each(function () {
//     var $this = $(this),
//       selectOption = $this.find("option"),
//       selectOptionLength = selectOption.length,
//       selectedOption = selectOption.filter(":selected"),
//       dur = 500;
//     $this.hide();
//     $this.wrap('<div class="select"></div>');
//     $("<div>", {
//       class: "select__gap",
//       text: "-- Choose truck type",
//     }).insertAfter($this);
//     var selectGap = $this.next(".select__gap");
//     $("<ul>", {
//       class: "select__list",
//     }).insertAfter(selectGap);
//     var selectList = selectGap.next(".select__list");
//     // Add li - option items
//     for (var i = 0; i < selectOptionLength; i++) {
//       $("<li>", {
//         class: "select__item",
//         html: $("<span>", {
//           text: selectOption.eq(i).text(),
//         }),
//       })
//         .attr("data-value", selectOption.eq(i).val())
//         .appendTo(selectList);
//     }
//     var selectItem = selectList.find("li");
//     selectList.slideUp(0);
//     selectGap.on("click", function () {
//       if (!$(this).hasClass("on")) {
//         $(this).addClass("on");
//         selectList.slideDown(dur);
//         selectItem.on("click", function () {
//           var chooseItem = $(this).data("value");
//           $("select").val(chooseItem).attr("selected", "selected");
//           selectGap.text($(this).find("span").text());
//           selectList.slideUp(dur);
//           selectGap.removeClass("on");
//         });
//       } else {
//         $(this).removeClass("on");
//         selectList.slideUp(dur);
//       }
//     });
//   });

//   $("#about .section-columns .tab-about .tabs-nav ul li").each(function () {
//     $(this).click(function () {
//       $("#about .section-columns .tab-about .tabs-nav ul li")
//         .not(this)
//         .removeClass("active");
//     });
//   });
// });

// let button0 = document.querySelector(".scroll-to__link");
// let sectionFirst = document.querySelector("#contacts");

// function scrollTo(element) {
//   window.scroll({
//     left: 0,
//     top: element.offsetTop,
//     behavior: "smooth",
//   });
// }
// if (button0) {
//   button0.addEventListener("click", () => {
//     scrollTo(sectionFirst);
//   });
// }

document.addEventListener("DOMContentLoaded", (e) => {

    function replaceTagsBasedOnWidth() {
    const widthThreshold = 1024;
    const ourTeamCards = document.querySelectorAll(".our-team-card");
    ourTeamCards.forEach(card => {
      let cardUrl = card.getAttribute("data-url");
      if (window.innerWidth <= widthThreshold) {
        if (card.tagName.toLowerCase() === "a") {
          const newDiv = document.createElement("div");
          newDiv.className = card.className;
          newDiv.innerHTML = card.innerHTML;
          newDiv.setAttribute("data-url", cardUrl);
          card.parentNode.replaceChild(newDiv, card);
          const linkedInDiv = newDiv.querySelector(".our-team-card-linkedin");
          if (linkedInDiv && linkedInDiv.tagName.toLowerCase() === "div") {
            const newLink = document.createElement("a");
            newLink.className = linkedInDiv.className;
            newLink.href = cardUrl;
            newLink.target = "_blank";
            newLink.innerHTML = linkedInDiv.innerHTML;
            linkedInDiv.parentNode.replaceChild(newLink, linkedInDiv);
          }
        }
      } else {
        if (card.tagName.toLowerCase() === "div") {
          const newLink = document.createElement("a");
          newLink.className = card.className;
          newLink.href = cardUrl || "#";
          newLink.target = "_blank";
          newLink.innerHTML = card.innerHTML;
          newLink.setAttribute("data-url", cardUrl);
          card.parentNode.replaceChild(newLink, card);
          const linkedInLink = newLink.querySelector(".our-team-card-linkedin");
          if (linkedInLink && linkedInLink.tagName.toLowerCase() === "a") {
            const newDiv = document.createElement("div");
            newDiv.className = linkedInLink.className;
            newDiv.innerHTML = linkedInLink.innerHTML;
            linkedInLink.parentNode.replaceChild(newDiv, linkedInLink);
          }
        }
      }
    });
  }
  replaceTagsBasedOnWidth();
  window.addEventListener("resize", replaceTagsBasedOnWidth);

  // Простой селект / первый элемент - селектор, класс, id, можете настраивать по своему усмотрению
  // new SS_Select('.super-select', {});

  // Мультиселект / placeholder - это текст который в селекторе пока ничего не выбрано.
  new SS_Select('.super-select', {
    placeholder: 'Select test data'
  });
});

let button0 = document.querySelector(".scroll-to__link");
let sectionFirst = document.querySelector("#contacts");

function scrollTo(element) {
  window.scroll({
    left: 0,
    top: element.offsetTop,
    behavior: "smooth",
  });

  setTimeout(() => {
    const input = element.querySelector(
      "input:not([type='hidden']):not([disabled]), textarea, select, button, a"
    );
    if (input) {
      input.focus();
    }
  }, 500);
}

if (button0 && sectionFirst) {
  button0.addEventListener("click", (e) => {
    e.preventDefault();
    scrollTo(sectionFirst);
  });
}

const anchors = document.querySelectorAll('a[href*="#"]:not(.go-to-form)')

for (let anchor of anchors) {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()

    const blockID = anchor.getAttribute('href').substr(1)
    if (!!blockID) {
      document.getElementById(blockID).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  const labels = document.querySelectorAll('.wpcf7-list-item-label');

  labels.forEach(label => {
    label.innerHTML = label.innerHTML.replace(
      'Later',
      '<span class="later-text">Later</span>'
    ).replace(
      'ASAP',
      '<span class="asap-text">ASAP</span>'
    );
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const checkboxes = document.querySelectorAll('input[name="contact-preferenct[]"]');

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        checkboxes.forEach(cb => {
          if (cb !== this) {
            cb.checked = false;
          }
        });
      }
    });
  });
});

document.querySelectorAll('.magic-validate').forEach((wrapper) => {
  const input = wrapper.querySelector('input');
  if (!input) return; // Пропускаем, если внутри нет инпута

  const checkEmpty = () => {
    if (input.value.trim() === '') {
      wrapper.classList.add('magic-validate-on');
    } else {
      wrapper.classList.remove('magic-validate-on');
    }
  };

  // Проверяем при загрузке страницы
  checkEmpty();

  // Проверяем при каждом вводе
  input.addEventListener('input', checkEmpty);
});